import { useContext } from "react";

import { WarehouseContext } from "../context/WarehouseContext";

export default function useWarehouseContext() {
  const warehouseContext = useContext(WarehouseContext);

  return warehouseContext;
}
